

/**
 * this createes a number of path objects that are used in building the tree
 * @param {*} rEntries the entries that needs to be mapped
 */
export default function pathMapper(rEntries) {
    let pathBuilder = [];
    let entries = Object.entries(rEntries);
    if (entries.length >= 1) {
        entries.forEach(element => {
            if (element[1].children === undefined) {
                console.log('nothing');
            } else if (element[1].children.length >= 1) {
                element[1].children.forEach(child => {
                    let entry = {
                        id: `pathTL${element[1].parent}${child}`,
                        startPoint: element[1].parent,
                        endPoint: child,
                        colour: "#000"
                    };
                    pathBuilder.push({
                        entry
                    });
                });
            }
        });
    }
    return pathBuilder;
}




// WEBPACK FOOTER //
// ./src/services/pathMapper.js